import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=0cf465be&scoped=true&"
import script from "./Top.vue?vue&type=script&lang=js&"
export * from "./Top.vue?vue&type=script&lang=js&"
import style0 from "./Top.vue?vue&type=style&index=0&id=0cf465be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf465be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf465be')) {
      api.createRecord('0cf465be', component.options)
    } else {
      api.reload('0cf465be', component.options)
    }
    module.hot.accept("./Top.vue?vue&type=template&id=0cf465be&scoped=true&", function () {
      api.rerender('0cf465be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/components/Top.vue"
export default component.exports